import { render, staticRenderFns } from "./p2.vue?vue&type=template&id=ba8f3b78&scoped=true&"
import script from "./p2.vue?vue&type=script&lang=js&"
export * from "./p2.vue?vue&type=script&lang=js&"
import style0 from "./p2.vue?vue&type=style&index=0&id=ba8f3b78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba8f3b78",
  null
  
)

export default component.exports